import "./ToastContainer.css";

const ICONS = {
  success: "✅",
  error: "❌",
  warning: "⚠️",
  info: "ℹ️",
  bluetooth: "🔵",
};

export default function ToastContainer({ toasts, dismiss }) {
  if (!toasts.length) return null;

  return (
    <div className="toast-wrapper">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`toast toast--${t.type}`}
          onClick={() => dismiss(t.id)}
        >
          <span className="toast-icon">{ICONS[t.type] ?? ICONS.info}</span>
          <div className="toast-body">
            {t.title && <div className="toast-title">{t.title}</div>}
            {t.message && <div className="toast-message">{t.message}</div>}
          </div>
          <button className="toast-close" onClick={() => dismiss(t.id)}>
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}
